var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/pv_system.template.html');
var MapView = require("views/map.view.ts");

var TheView = GenericView.extend({
    el: '#pv_system',
    tagName: '',
	template: Handlebars.compile(Template),
	fields: [],
	fileName: null,
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "pv_system");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
        this.showMap();
    },
    events: {
        "input .to-validation input": "validateIt",
        "change input[name='parametric_analysis']": "checkParametricAnalysis",
        "change input.slider": "fillTextBoxWithSliderValue",
        "input .input-slider": "changeSliderValue",
        "change select.select-production-profile": "showProperSelection",
        "click #collapseDescription": "collapseDescription",
        "click #uploadMeasurements": "uploadFile"
    },
    showMap: function(e)
    {
        if(this.mapView == null)
            this.mapView = new MapView();

        this.mapView.renderMap();
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    checkParametricAnalysis: function() {
        $("#parametric-analysis").find(".disabled").addClass("to-validation").removeClass("disabled");
        $("#parametric-analysis ." + $("input[name='parametric_analysis']:not(:checked)").val()).addClass("disabled").removeClass("to-validation");

        if ($('input[name="parametric_analysis"]:checked').val() == 'false') {
            $('#examinationOf9Analysis').prop("disabled",true);
            $('#examinationOf9Analysis').parent().css("opacity","0.7");
            $('#maxNPVAnalysis').prop("disabled",true);
            $('#maxNPVAnalysis').parent().css("opacity","0.7");
            $('#maxSelfSufficiencyAnalysis').prop("disabled",true);
            $('#maxSelfSufficiencyAnalysis').parent().css("opacity","0.7");
            $('#costEffectiveAnalysis').prop("disabled",true);
            $('#costEffectiveAnalysis').parent().css("opacity","0.7");
            $("input[name=analysis_method][value=EXHAUSTIVE_ANALYSIS]").prop('checked', true);
        } else {
            $('#examinationOf9Analysis').prop("disabled",false);
            $('#examinationOf9Analysis').parent().css("opacity","1");
            $('#maxNPVAnalysis').prop("disabled",false);
            $('#maxNPVAnalysis').parent().css("opacity","1");
            $('#maxSelfSufficiencyAnalysis').prop("disabled",false);
            $('#maxSelfSufficiencyAnalysis').parent().css("opacity","1");
            $('#costEffectiveAnalysis').prop("disabled",false);
            $('#costEffectiveAnalysis').parent().css("opacity","1");
        }
    },
    collapseDescription: function(event) {
        var btn = event.currentTarget;
        GenericView.prototype.collapseDescription(btn);
    },
    fillTextBoxWithSliderValue: function(event) {
        $input_id = $(event.currentTarget).data("input-id");
        $input_value = $(event.currentTarget).val();
        $("#" + $input_id).val($input_value);
    },
    changeSliderValue: function(event) {
        var slider_data_id = $(event.currentTarget).attr('id');
        var input_value = $(event.currentTarget).val();
        $('[data-input-id="' + slider_data_id + '"]').val(input_value);
    },
    showProperSelection: function(event) {
        var selectionValue = $(event.currentTarget).val();

        if(selectionValue == "my_measurements") {
            this.$el.find(".my_measurements").removeClass("d-none").addClass("d-block");
            this.$el.find(".system_position").removeClass("d-block").addClass("d-none");

            this.$el.find(".map-lat-lng").removeClass("to-validation");
        } else {
            this.$el.find(".system_position").removeClass("d-none").addClass("d-block");
            this.$el.find(".my_measurements").removeClass("d-block").addClass("d-none");

            this.$el.find(".map-lat-lng").addClass("to-validation");
        }
    },
    uploadFile: function() {
        var self = this;
        if ($("#measurementsFile")[0].files[0]) {
            var file = $("#measurementsFile")[0].files[0];
            this.fileName = Date.now() + "-" + file.name;
            var formData = new FormData();
            formData.set('file', file, this.fileName);

            $.ajax({
                url: "api/upload",
                type: "POST",
                enctype: 'multipart/form-data',
                cache: false,
                processData: false,
                contentType: false,
                data: formData,
            }).done(function(response) {
                self.$el.find(".fileSucceed").show().delay(5000).fadeOut();
            }).fail(function(resp, xhr, errorMessage) {
                console.error("resp: ", resp);
                console.error("xhr: ", xhr);
                console.error("status: ", errorMessage);
            });
        }
    },
    getAllData: function() {
        var generation =  $("select.select-production-profile").val() == "my_measurements" ? "Customized" : "NotCustomized";
        var file_name = $("select.select-production-profile").val() == "my_measurements" ? this.fileName : null;

        var data = {
            generation: generation,
            filename: file_name,
            PVparametricFlag: $("input[name='parametric_analysis']:checked").val() == "true" ? true : false,
            pv_sz_max: this.convertToInt("#pv_max"),
            pv_sz_min: this.convertToInt("#pv_min"),
            pv_single: isNaN(this.convertToInt("#pv_single")) ? 100 : this.convertToInt("#pv_single") ,
            degr: this.convertToFloat("#deg_rate"),
            inv_eff: this.convertToInt("#inv_eff"),
            lat: this.convertToFloat("#fi"),
            lng: this.convertToFloat("#fo"),
            single_slope : this.convertToInt("#single_slope"),
            azimuth : this.convertToInt("#azimuth"),
        };

        return data;
    }
});

module.exports= TheView;